export default __webpack_public_path__ + "static/media/TPIcon.5e6ab3f1.png";